var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M2.09375 0.69165V0.692627H4.82129C7.21149 0.692627 8.75586 1.97734 8.75586 3.96899C8.75579 5.26901 8.10296 6.02251 7.71289 6.35767L7.37793 6.64478L7.76172 6.85962C8.69307 7.38395 9.24707 8.41514 9.24707 9.62134C9.24707 11.8613 7.53231 13.3077 4.87598 13.3079H0.5V2.00708C0.507398 1.29462 1.075 0.718165 1.7832 0.69165H2.09375ZM11.9404 10.1848C12.8004 10.1848 13.4999 10.8831 13.5 11.7463C13.5 12.6085 12.8005 13.3079 11.9404 13.3079C11.0827 13.3078 10.3867 12.6085 10.3867 11.7463C10.3868 10.8832 11.0827 10.1849 11.9404 10.1848ZM3.60254 7.74341C3.13853 7.80792 2.92871 8.09078 2.92871 8.63306V11.1711L5.05078 11.1731C6.10038 11.172 6.75178 10.5317 6.75195 9.44946C6.75195 8.3955 6.08361 7.74341 5.05078 7.74341H3.60254ZM3.71777 2.76001C3.17555 2.79599 2.92871 3.07488 2.92871 3.65942V5.79126H4.83887C5.91152 5.79108 6.29389 4.9615 6.29395 4.25122C6.29395 3.31776 5.73603 2.76001 4.80469 2.76001H3.71777Z",
    fill: "#A6A9B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingIcon);
export default __webpack_public_path__ + "static/media/BOOKING_ICON.aed272ac3a86da606b69a75cafd18f28.svg";
export { ForwardRef as ReactComponent };